var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.378,
    height: 19.002,
    viewBox: "0 0 29.378 19.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-189.776 -114.679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.776 114.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.775,122.365h-7.637a1.787,1.787,0,0,0-1.312.515,1.654,1.654,0,0,0-.551,1.273,1.872,1.872,0,0,0,.533,1.314,1.913,1.913,0,0,0,1.312.552h3.718a5.861,5.861,0,1,1-5.553-7.685,5.7,5.7,0,0,1,3.5,1.18l2.872-2.34a9.376,9.376,0,0,0-6.372-2.491,9.5,9.5,0,1,0,9.32,11.336,12.792,12.792,0,0,0,.171-1.827Z",
    transform: "translate(-195.776 -114.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.054,114.679l-4.966,12.488.007,0a1.78,1.78,0,0,0,.016,1.4,1.707,1.707,0,0,0,.992.973,1.724,1.724,0,0,0,1.4-.021,1.8,1.8,0,0,0,.978-1l4.967-12.49Z",
    transform: "translate(-218.33 -114.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.576,132.577a1.828,1.828,0,1,0,1.023,2.372A1.829,1.829,0,0,0,220.576,132.577Z",
    transform: "translate(-218.073 -117.102)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f7cd1eed2eb0be293334ab2442b4b9ed.svg";
export { ForwardRef as ReactComponent };